<template>
  <div class="card-body maxheight">
    <div class="row justify-content-center">
      <div class="col-8">
        <div class="row lead mx-2 mt-4">
          {{ data.title }}
        </div>
        <div class="row mx-4 my-4 justify-content-center">
          <div class = "col">
          <form>
            <div class="mb-3" v-for="(response, key) in data.responses" :key="key">
              <label class="form-label"><span v-if="key!='q2'">*</span>{{ response }}</label>
              <input v-if="response=='Email:'" :v-model="answer[key]" :name="key" :value="userQ[key] == '' ? answer[key] : userQ[key]" v-bind:id="key"
                @input="event => answer[key] = event.target.value" @change="onValueChange('email', answer[key], key)" type="email"
                class="form-control" />
              <input v-else :v-model="answer[key]" :name="key" :value="userQ[key] == '' ? answer[key] : userQ[key]" v-bind:id="key"
                @input="event => answer[key] = event.target.value" @change="onValueChange('text', answer[key], key)" type="text"
                class="form-control" />
              <p v-if="response=='Email:'" v-show="emailError===true" class="text-danger small">Please enter a correctly formatted email address</p>
              
            </div>
          </form>
          <p><span class="small float-right">*required</span> </p>
          <p v-if="textError===true" class="text-danger small">Please fill in all required fields </p>
          
          
          </div>
          
        </div>
        

      </div>
    </div>
  </div>
  <div class="card-footer border border-rounded">
    <div class="row justify-content-center">
      <div @click="previous()" class="btn btn-small nsc-cta mx-4 my-2">
      Previous
      </div>
      <div @click="validateAnswer" class="btn btn-small nsc-cta blue mx-4 my-2">
        Next
      </div>
    </div>
  </div>

</template>
<script>

export default {
  name: "FillForm",
  props: ["data", "nextQ","answers","user", "prevQ"],
  emits: ["nextQuestion", "buildUser","previousBuild"],
  data() {
    return {
      responses: this.data.responses,
      answer: {},
      emailError:null,
      textError:null,
      errors: 0,
      proceed: false,
      userQ:{
      q1: this.user.company,
      q2: this.user.subsector,
      q3: this.user.firstName,
      q4: this.user.lastName,
      q5: this.user.email,},
      emailRegex :/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
      

    };
  },
  methods: {
    validateAnswer() {
      // const required = Object.keys(this.answer).filter(key => key != 'q2').length >= 4 ? true : false;

      if (this.emailError != true && this.textError != true) {
        let counter = 0
        for (let key in this.answer) {
          // console.log(key, this.answer[key].length < 2)
          if (key !='q2' && this.answer[key].length < 2){
            counter ++
          }
          if(key === 'q5' && !this.answer[key].trim().match(this.emailRegex) ){
            counter ++
          }
        }
        counter > 0 ? this.proceed = false : this.proceed = true
        // this.proceed = false
      } 
      if(this.proceed) {
        this.$emit('buildUser', this.answer)
        this.$emit('nextQuestion', this.nextQ, this.answer)
      }
      if(this.proceed === false) {
        let list = document.querySelectorAll('input')
        // console.log(list)
        list.forEach(ele => ele.id == 'q2' || ele.value.length >= 2 ? ele : ele.classList.add('border-danger'))
        this.textError = true
      }
    },
    onValueChange(text, val, key) {
      // console.log(text, val);

      if(text == 'email'){
        
        if(val.trim().match(this.emailRegex)) {
          document.getElementById(key).classList.remove('border-danger')
          
          return this.emailError = false
        } else {
          document.getElementById(key).classList.add('border-danger')
          
           return this.emailError = true
           
        }
      }
      if(text == 'text'){
        if(key != 'q2'){
          if(val.trim().length > 2 ) {
            document.getElementById(key).classList.remove('border-danger')
          
          
            return this.textError = false
          
          } else {
            document.getElementById(key).classList.add('border-danger')
          
            return this.textError = true
           
          }
        }
      }

    },
    previous(){
      this.$emit("previousBuild", this.prevQ, this.answer)
    },
    
  },
  mounted(){
    
      for (let key in this.userQ) {
        this.answer[key] = this.userQ[key]
        
      }
      // console.log (this.answer)

    }
};
</script>